/* eslint-disable react/no-array-index-key */
import React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import GenericList from '@ts-core/core/components/GenericList';

import SubjectItemCard from '../SubjectItemCard';

interface SubjectItemsListProps<TItem extends object> {
  items?: TItem[];
  loading?: boolean;
  getName?: (item?: TItem) => React.ReactNode;
  getBackgroundImage?: (item?: TItem) => string;

  noItemsMessage?: string;
  onSelectItem?: (item: TItem) => void;
}

const SubjectItemsList = <TItem extends object>(props: SubjectItemsListProps<TItem>) => {
  const { items, getName, getBackgroundImage, loading, noItemsMessage, onSelectItem } = props;

  return (
    <Box mt={2}>
      <Grid container spacing={2}>
        <GenericList
          items={items}
          emptyMessage={
            <Grid item xs={12} sm={4} md={4} lg={3}>
              {noItemsMessage}
            </Grid>
          }
          disableEmptyMessageContainer
          skeletonsCount={3}
          renderItem={(index, item) => (
            <Grid key={index} item xs={12} sm={4} md={4} lg={3}>
              <SubjectItemCard item={item} loading={loading} getName={getName} getBackgroundImage={getBackgroundImage} onSelectItem={onSelectItem} />
            </Grid>
          )}
        />
      </Grid>
    </Box>
  );
};

export default SubjectItemsList;
